import { ctaItems } from "@/mocks/homeData";
import { Shell } from "./ui";

export default function CtaBand() {
  return (
    <section className="bg-primary-950 text-background-50">
      <Shell>
        <div className="flex flex-col gap-6 py-12 lg:flex-row lg:items-center lg:justify-between md:py-16">
          <div className="max-w-2xl">
            <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3 py-1 text-xs font-semibold text-accent-300">
              <i className="ri-megaphone-line" />
              每一次关键反转，都值得被留下
            </div>
            <h2 className="font-heading text-2xl font-extrabold leading-tight text-background-50 md:text-4xl">
              有线索、有存疑、有后续？
              <br className="hidden sm:block" />
              交给黑料王来核与追。
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/75">
              看到可疑截图、回放或正在反转的争议，把材料投递给我们做真假验证与实锤拆解，我们会把结论和后续进展持续同步回页面。
            </p>
          </div>

          <div id="report" className="grid w-full shrink-0 grid-cols-1 gap-3 sm:grid-cols-3 lg:w-[560px] lg:grid-cols-1 xl:grid-cols-3">
            {ctaItems.map((c) => (
              <a
                key={c.title}
                href="#top"
                className="group rounded-2xl border border-background-50/15 bg-background-50/5 p-4 transition hover:border-accent-500/50 hover:bg-background-50/10"
              >
                <span className="mb-2 grid h-9 w-9 place-items-center rounded-lg bg-accent-500 text-foreground-950 transition group-hover:-translate-y-0.5">
                  <i className={`${c.icon} text-lg`} />
                </span>
                <span className="block font-heading text-base font-bold text-background-50">{c.title}</span>
                <span className="mt-1 block text-xs leading-relaxed text-background-100/70">{c.desc}</span>
              </a>
            ))}
          </div>
        </div>
      </Shell>
    </section>
  );
}